const SmartPrint = (function() {
            // Internal State
            let globalConfig = {};
            let fileConfigs = {};
            let isInitialized = false;

            // Default Main Settings Object
            const defaultSettings = {
                containerSelector: '#Viewer',
                blockSelector: '.cue',
                fileAttribute: 'data-file',
                pageSize: 'A4 portrait',
                pageWidth: '210mm',
                pageHeight: '297mm',

                // Title Page Defaults
                hasTitlePage: false,
                titlePageText: '',

                // Visual Effects Defaults (Calibrated for exactly 20 holes on A4)
                showBindingMarks: false,
                bindSpacing: 14.85,
                bindCombH: 5.8,
                bindCombW: 6.3,
                bindHoleH: 7.1,
                bindHoleW: 3.2,
                bindHoleL: 4.2,

                // Global Page Margins (applies to whole document)
                pageMt: 10,
                pageMb: 10,
                pageMl: 15,
                pageMr: 10,

                // Global Page Number defaults
                pageNoFormat: '{n}', //'Page {n}',
                pageNoAlign: 'center', // left, center, right

                // Fallback Defaults if [data-file] doesn't specify
                defaultHeaderLeft: '',
                defaultHeaderRight: '',
                defaultFooterText: '',
                defaultHeaderMt: 0,
                defaultHeaderMb: 0,
                defaultFooterMt: 0,
                defaultFooterMb: 0
            };


            // --- LOCAL STORAGE LOGIC ---
            function hashString(str) {
                let hash = 0;
                for (let i = 0, len = str.length; i < len; i++) {
                    let chr = str.charCodeAt(i);
                    hash = ((hash << 5) - hash) + chr;
                    hash |= 0; // Convert to 32bit integer
                }
                return hash.toString();
            }

            function getStorageKey() {
                const urlParams = new URLSearchParams(window.location.search);
                const prayerParam = urlParams.get('prayer');
                if (prayerParam) {
                    return 'sp_settings_' + hashString(prayerParam);
                }
                return null;
            }

            function loadSettings() {
                const key = getStorageKey();
                if (!key) return;

                try {
                    const savedData = localStorage.getItem(key);
                    if (savedData) {
                        const parsed = JSON.parse(savedData);

                        // Merge saved global configuration
                        if (parsed.globalConfig) {
                            globalConfig = { ...globalConfig, ...parsed.globalConfig };
                        }

                        // Merge saved individual file configurations
                        if (parsed.fileConfigs) {
                            Object.keys(parsed.fileConfigs).forEach(fileName => {
                                if (fileConfigs[fileName]) {
                                    fileConfigs[fileName] = { ...fileConfigs[fileName], ...parsed.fileConfigs[fileName] };
                                } else {
                                    fileConfigs[fileName] = parsed.fileConfigs[fileName];
                                }
                            });
                        }
                        console.log("SmartPrint: Successfully loaded settings for hash:", key);
                    }
                } catch(e) {
                    console.error("SmartPrint: Failed to load settings from localStorage", e);
                }
            }

            function saveSettings() {
                const key = getStorageKey();
                if (!key) return; // Do not save if there is no prayer parameter

                try {
                    const payload = {
                        globalConfig: globalConfig,
                        fileConfigs: fileConfigs
                    };
                    localStorage.setItem(key, JSON.stringify(payload));
                } catch(e) {
                    console.error("SmartPrint: Failed to auto-save settings", e);
                }
            }
            // --------------------------

            // 1. Initialization
            function init(userSettings = {}) {
                if (isInitialized) return;

                globalConfig = { ...defaultSettings, ...userSettings };

                const sourceContainer = document.querySelector(globalConfig.containerSelector);
                if (!sourceContainer) {
                    console.error('SmartPrint: containerSelector not found.');
                    return;
                }

                document.body.classList.add('sp-print-mode-active');

                injectCSS();
                parseSourceFiles(); // Grabs defaults from HTML document structure
                loadSettings();     // Overwrites defaults with saved localStorage settings (if any exist)
                buildSystemContainers();
                buildUI();
                renderPages();

                isInitialized = true;
            }

            // 2. Teardown / Exit
            function exit() {
                document.body.classList.remove('sp-print-mode-active');

                const root = document.getElementById('sp-system-root');
                if (root) root.remove();

                const styles = document.getElementById('sp-injected-styles');
                if (styles) styles.remove();

                isInitialized = false;

                // Restore navbar for preview page functionality
                $('#navbarNavbar').show();
                $('body').css('grid-template-rows', '');
            }

            // 3. Inject Dependency-Free Vanilla CSS
            function injectCSS() {
                const css = `
                    :root {
                        --page-margin-left: 15mm;
                        --bind-spacing: 14.85mm;
                        --bind-comb-h: 5.8mm;
                        --bind-comb-w: 6.3mm;
                        --bind-hole-h: 7.1mm;
                        --bind-hole-w: 3.2mm;
                        --bind-hole-l: 4.2mm;
                    }
                    /* Hide Original Content */
                    body.sp-print-mode-active ${globalConfig.containerSelector} {
                        display: none !important;
                    }

                    /* myPechaCounter setup */
                        #sp-pages-container {
                            display: block;
                            list-style: none;
                            counter-reset: myPechaCounter;
                        }
                        .sp-page-content > div.cue{
                            counter-increment: myPechaCounter 1;
                        }
                        .sp-page-content > div.cue::before {
                            display: inline-block !important;
                            content: counter(myPechaCounter);
                            color: darkblue;
                            font-size: 70%;
                            position: absolute;
                            translate: 0px 4px;
                            /*left: calc(15mm - 3ch - 1px);*/
                            left: calc(var(--page-margin-left) - 3ch - 1px);
                            visibility: visible;
                            display: inline-block;
                            width: 3ch;
                            text-align: right;
                            font-variant-numeric: tabular-nums;
                            background: white url(https://tulkuajam.org/EasyViewerWebBab/EasyViewer5/dist/images/background.jpg);
                            box-sizing: content-box;
                        }

                    /* BINDING MARKS CSS */
                    .sp-show-binding .sp-a4-page::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: calc(var(--bind-hole-l) + var(--bind-hole-w) + 5mm); /* Total width for binding effect */
                        height: 100%;
                        background-image:
                            /* 1. Glossy Black Plastic Combs */
                            linear-gradient(to bottom,
                                transparent 0px,
                                transparent calc((var(--bind-spacing) - var(--bind-comb-h)) / 2),
                                #0a0a0a calc((var(--bind-spacing) - var(--bind-comb-h)) / 2),
                                #4a4a4a calc((var(--bind-spacing) - var(--bind-comb-h)) / 2 + 1mm), /* 3D highlight */
                                #000 calc((var(--bind-spacing) + var(--bind-comb-h)) / 2),
                                transparent calc((var(--bind-spacing) + var(--bind-comb-h)) / 2),
                                transparent 100%
                            ),
                            /* 2. Rectangular Punched Holes */
                            linear-gradient(to bottom,
                                transparent 0px,
                                transparent calc((var(--bind-spacing) - var(--bind-hole-h)) / 2),
                                #6b7280 calc((var(--bind-spacing) - var(--bind-hole-h)) / 2), /* top inner shadow */
                                #e5e7eb calc((var(--bind-spacing) - var(--bind-hole-h)) / 2 + 0.5mm), /* hole depth */
                                #e5e7eb calc((var(--bind-spacing) + var(--bind-hole-h)) / 2 - 0.5mm),
                                #6b7280 calc((var(--bind-spacing) + var(--bind-hole-h)) / 2), /* bottom inner shadow */
                                transparent calc((var(--bind-spacing) + var(--bind-hole-h)) / 2),
                                transparent 100%
                            );
                        background-size:
                            var(--bind-comb-w) var(--bind-spacing),
                            var(--bind-hole-w) var(--bind-spacing);
                        background-position:
                            0 0,       /* Combs align to left edge */
                            var(--bind-hole-l) 0;    /* Holes sit underneath the right tip of the combs */
                        background-repeat: repeat-y;
                        z-index: 10;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }

                    /* Print Overrides */
                    @media print {
                        @page { margin: 0; size: ${globalConfig.pageSize}; }
                        body {
                            margin: 0;
                            background: white;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        .sp-no-print {
                            display: none !important;
                        }
                        #sp-pages-container {
                            display: block;
                        }
                        .sp-a4-page {
                            margin: 0 !important;
                            box-shadow: none !important;
                            border: none !important;
                            page-break-after: always;
                            break-after: page;

                            z-index: 0;
                            font-size: 20px;
                        }
                        /* myPechaCounter setup override on print */
                        .sp-page-content > div.cue::before {
                            background: white!important; /* make background white */
                        }
                        /* Hide the spiral binding marks on actual printed paper */
                        .sp-show-binding .sp-a4-page::before {
                            display: none !important;
                        }
                    }

                    /* Screen Preview Overrides */
                    @media screen {
                        #sp-system-root {
                            font-family: system-ui, sans-serif;
                            padding-top: 20px;
                            font-size: 20px;
                        }
                        .sp-a4-page {
                            z-index: 0;
                            background: white; margin: 0 auto 2rem auto;
                            box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05);
                            border: 1px solid #d1d5db;
                        }
                        .sp-page-content{
                            border: 1px dotted lightblue;
                        }
                        /* myPechaCounter setup override on screen*/
                        .sp-page-content > div.cue::before {
                            background: white!important; /* make background white */
                        }
                    }

                    /* UI Control Panel */
                    .sp-ui-panel {
                        max-width: ${globalConfig.pageWidth}; margin: 0 auto 20px auto;
                        background: #fff; border-radius: 8px; border: 1px solid #e5e7eb;
                        padding: 20px; box-shadow: 0 4px 6px rgba(0,0,0,0.05); box-sizing: border-box;
                    }
                    .sp-ui-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e5e7eb; padding-bottom: 15px; margin-bottom: 15px; }
                    .sp-ui-title { font-size: 1.25rem; font-weight: bold; margin: 0; color: #111827; }
                    .sp-btn { padding: 8px 16px; border: none; border-radius: 4px; font-weight: bold; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; font-size: 14px;}
                    .sp-btn-primary { background: #4f46e5; color: white; }
                    .sp-btn-primary:hover { background: #4338ca; }
                    .sp-btn-dark { background: #1f2937; color: white; }
                    .sp-btn-dark:hover { background: #111827; }
                    .sp-btn-danger { background: #ef4444; color: white; }
                    .sp-btn-danger:hover { background: #dc2626; }

                    /* Config Forms */
                    .sp-file-config { background: #f9fafb; border: 1px solid #e5e7eb; padding: 15px; border-radius: 6px; margin-bottom: 15px; }
                    .sp-global-config { background: #eff6ff; border: 2px solid #93c5fd; padding: 15px; border-radius: 6px; margin-bottom: 25px; }
                    .sp-file-title { font-weight: bold; color: #4338ca; margin-bottom: 10px; font-size: 14px; border-bottom: 1px solid #e5e7eb; padding-bottom: 5px;}
                    .sp-global-title { font-weight: bold; color: #1d4ed8; margin-bottom: 10px; font-size: 15px; border-bottom: 1px solid #bfdbfe; padding-bottom: 5px;}

                    /* Collapsible Utilities */
                    .sp-collapsible-header { cursor: pointer; user-select: none; display: flex; justify-content: space-between; align-items: center; }
                    .sp-collapsible-header::after { content: '▼'; font-size: 12px; transition: transform 0.2s ease; transform: rotate(0deg); color: #6b7280; }
                    .sp-collapsible-header.sp-expanded::after { transform: rotate(180deg); }
                    .sp-collapsible-content { display: none; padding-top: 15px; }
                    .sp-collapsible-content.sp-expanded { display: block; }

                    .sp-form-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr)); gap: 10px; }
                    .sp-form-group { display: flex; flex-direction: column; }
                    .sp-form-group label { font-size: 11px; font-weight: 600; color: #4b5563; margin-bottom: 4px; white-space: nowrap; }
                    .sp-form-group input, .sp-form-group select { padding: 6px 8px; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; width: 100%; box-sizing: border-box;}

                    /* A4 Page Layout */
                    .sp-a4-page {
                        width: ${globalConfig.pageWidth};
                        height: ${globalConfig.pageHeight};
                        box-sizing: border-box;
                        /* Padding is now handled dynamically per file config */
                        display: flex; flex-direction: column; position: relative; overflow: hidden;
                    }
                    .sp-page-header {
                        flex: 0 0 auto;
                        /*border-bottom: 2px solid #b91c1c;*/
                        display: flex;
                        justify-content: space-between;
                        font-weight: bold;
                        font-size: 14px;
                        color: #7f1d1d;
                        letter-spacing: 0.05em;
                    }

                    .sp-page-content {
                        flex: 1 1 auto;
                        padding: 0mm 0;
                        overflow: hidden;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-around;
                        align-content: start;
                        text-align: center;
                    }
                    .sp-page-footer {
                        flex: 0 0 auto;
                        /* border-top: 1px solid #d1d5db;*/
                        display: flex;
                        flex-direction: column;
                        font-size: 12px;
                        color: #6b7280;
                        padding-top: 0px;
                    }
                    .sp-footer-main { display: flex; justify-content: space-between; }
                    .sp-page-number-box { font-weight: bold; font-size: 13px; color: #374151; }

                    /* Title Page Specific Styles */
                    .sp-title-page-wrapper {
                        display: block;
                        width: 100%;
                        padding-top: 25%;
                        text-align: center;
                        font-family: "Jomolhari", DFKai-SB, sans-serif;
                        font-size: 32px;
                        /* font-weight: bold; */
                        line-height: 1.5;
                        white-space: pre-wrap;
                        color: #111827;
                        box-sizing: border-box;
                        padding-left: 20mm;
                        padding-right: 20mm;
                    }
                `;
                const styleEl = document.createElement('style');
                styleEl.id = 'sp-injected-styles';
                styleEl.textContent = css;
                document.head.appendChild(styleEl);
            }

            // 4. Parse source to extract configurations
            function parseSourceFiles() {
                const source = document.querySelector(globalConfig.containerSelector);
                const fileBlocks = Array.from(source.querySelectorAll(`[${globalConfig.fileAttribute}]`));

                fileConfigs = {}; // reset

                fileBlocks.forEach(block => {
                    const fileName = block.getAttribute(globalConfig.fileAttribute);
                    if (fileName && !fileConfigs[fileName]) {
                        // Attempt to extract title text automatically
                        const engTitle = block.querySelector('.engSubtitleA, .engSubtitleP');
                        const chinTitle = block.querySelector('.chinSubtitleA, .chinSubtitleP');

                        fileConfigs[fileName] = {
                            headerLeft: '',//engTitle ? engTitle.innerText.trim() : globalConfig.defaultHeaderLeft,
                            headerRight: '',//chinTitle ? chinTitle.innerText.trim() : globalConfig.defaultHeaderRight,
                            footerText: '', //fileName,
                            headerMt: globalConfig.defaultHeaderMt,
                            headerMb: globalConfig.defaultHeaderMb,
                            footerMt: globalConfig.defaultFooterMt,
                            footerMb: globalConfig.defaultFooterMb
                        };
                    }
                });

                // If no data-file was found at all, create a default "Document" fallback
                if (Object.keys(fileConfigs).length === 0) {
                    fileConfigs['DefaultDocument'] = {
                        headerLeft: globalConfig.defaultHeaderLeft,
                        headerRight: globalConfig.defaultHeaderRight,
                        footerText: globalConfig.defaultFooterText,
                        headerMt: globalConfig.defaultHeaderMt,
                        headerMb: globalConfig.defaultHeaderMb,
                        footerMt: globalConfig.defaultFooterMt,
                        footerMb: globalConfig.defaultFooterMb
                    };
                }
            }

            // 5. Build Base DOM structure
            function buildSystemContainers() {
                const root = document.createElement('div');
                root.id = 'sp-system-root';
                root.innerHTML = `
                    <div id="sp-ui-container" class="sp-no-print"></div>
                    <div id="sp-pages-container"></div>
                `;
                document.body.appendChild(root);
            }

            // 6. Generate the interactive Vanilla UI
            function buildUI() {
                const uiContainer = document.getElementById('sp-ui-container');

                let html = `
                    <div class="sp-ui-panel">
                        <div class="sp-ui-header">
                            <div>
                                <h2 class="sp-ui-title">Smart Print Settings</h2>
                                <span style="font-size:12px; color:#6b7280;">Modify margins and headers, then re-render.</span>
                            </div>
                            <div style="display:flex; gap:10px;">
                                <button class="sp-btn sp-btn-danger" onclick="SmartPrint.exit()">Exit</button>
                                <button class="sp-btn sp-btn-primary" onclick="SmartPrint.renderPages()">Render Pages</button>
                                <button class="sp-btn sp-btn-dark" onclick="window.print()">Print</button>
                            </div>
                        </div>
                        <div class="sp-config-list">
                `;

                // GLOBAL SETTINGS PANEL
                html += `
                    <div class="sp-global-config">
                        <div class="sp-global-title sp-collapsible-header" onclick="SmartPrint.toggleCollapse(this)">Global Document Settings (Applies to all pages)</div>

                        <div class="sp-collapsible-content">
                            <!-- TITLE PAGE SECTION -->
                            <div style="font-size: 11px; font-weight: bold; color: #4b5563; text-transform: uppercase; margin-bottom: 8px; border-bottom: 1px solid #bfdbfe; padding-bottom: 5px;">Title Page</div>
                            <div class="sp-form-group" style="margin-bottom: 10px; flex-direction: row; align-items: center; gap: 8px;">
                                <input type="checkbox" id="sp-has-title-page" ${globalConfig.hasTitlePage ? 'checked' : ''} onchange="SmartPrint.updateGlobal('hasTitlePage', this.checked); document.getElementById('sp-title-text-container').style.display = this.checked ? 'block' : 'none';">
                                <label for="sp-has-title-page" style="margin:0; font-size:13px; cursor:pointer;">Include Title Page (Adds 2 blank pages at the front)</label>
                            </div>
                            <div id="sp-title-text-container" style="display: ${globalConfig.hasTitlePage ? 'block' : 'none'}; text-align: center; margin-bottom: 20px;">
                                <textarea rows="4" style="width: 80%; margin: 0 auto; padding: 10px; border: 1px solid #d1d5db; border-radius: 4px; font-family: inherit; font-size: 14px; text-align: center;" placeholder="Enter document title here... (Supports multiple lines)" onchange="SmartPrint.updateGlobal('titlePageText', this.value)">${globalConfig.titlePageText}</textarea>
                            </div>

                            <!-- VISUAL EFFECTS SECTION (ADDED BINDING MARKS) -->
                            <div style="font-size: 11px; font-weight: bold; color: #4b5563; text-transform: uppercase; margin-bottom: 8px; border-top: 1px solid #bfdbfe; padding-top: 10px;">Visual Effects</div>
                            <div class="sp-form-group" style="margin-bottom: 15px; flex-direction: row; align-items: center; gap: 8px;">
                                <input type="checkbox" id="sp-show-binding" ${globalConfig.showBindingMarks ? 'checked' : ''} onchange="SmartPrint.updateGlobal('showBindingMarks', this.checked); document.getElementById('sp-binding-settings').style.display = this.checked ? 'block' : 'none';">
                                <label for="sp-show-binding" style="margin:0; font-size:13px; cursor:pointer;">Show Spiral Binding Marks (Left Edge)</label>
                            </div>

                            <div id="sp-binding-settings" style="display: ${globalConfig.showBindingMarks ? 'block' : 'none'}; background: #fff; padding: 15px; border: 1px dashed #93c5fd; border-radius: 6px; margin-bottom: 15px;">
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                                    <div style="font-size: 11px; font-weight: bold; color: #1d4ed8;">BINDING DIMENSIONS & POSITION</div>
                                    <button class="sp-btn" style="padding: 4px 8px; font-size: 10px; background: #e5e7eb; color: #374151; border: 1px solid #d1d5db;" onclick="SmartPrint.resetBindingSettings()">Reset Default</button>
                                </div>
                                <div class="sp-form-grid">
                                    <div class="sp-form-group">
                                        <label>Pitch/Spacing (mm)</label>
                                        <input type="number" step="0.01" value="${globalConfig.bindSpacing}" onchange="SmartPrint.updateGlobal('bindSpacing', this.value); document.documentElement.style.setProperty('--bind-spacing', this.value + 'mm');">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Comb Height (mm)</label>
                                        <input type="number" step="0.1" value="${globalConfig.bindCombH}" onchange="SmartPrint.updateGlobal('bindCombH', this.value); document.documentElement.style.setProperty('--bind-comb-h', this.value + 'mm');">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Comb Width (mm)</label>
                                        <input type="number" step="0.1" value="${globalConfig.bindCombW}" onchange="SmartPrint.updateGlobal('bindCombW', this.value); document.documentElement.style.setProperty('--bind-comb-w', this.value + 'mm');">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Hole Height (mm)</label>
                                        <input type="number" step="0.1" value="${globalConfig.bindHoleH}" onchange="SmartPrint.updateGlobal('bindHoleH', this.value); document.documentElement.style.setProperty('--bind-hole-h', this.value + 'mm');">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Hole Width (mm)</label>
                                        <input type="number" step="0.1" value="${globalConfig.bindHoleW}" onchange="SmartPrint.updateGlobal('bindHoleW', this.value); document.documentElement.style.setProperty('--bind-hole-w', this.value + 'mm');">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Hole Left Pos (mm)</label>
                                        <input type="number" step="0.1" value="${globalConfig.bindHoleL}" onchange="SmartPrint.updateGlobal('bindHoleL', this.value); document.documentElement.style.setProperty('--bind-hole-l', this.value + 'mm');">
                                    </div>
                                </div>
                            </div>

                            <div style="font-size: 11px; font-weight: bold; color: #4b5563; text-transform: uppercase; margin-bottom: 8px; margin-top: 5px; border-top: 1px solid #bfdbfe; padding-top: 10px;">Global Page Margins</div>
                            <div class="sp-form-grid" style="margin-bottom: 15px;">
                                <div class="sp-form-group">
                                    <label>Page M-Top (mm)</label>
                                    <input type="number" value="${globalConfig.pageMt}" onchange="SmartPrint.updateGlobal('pageMt', this.value)">
                                </div>
                                <div class="sp-form-group">
                                    <label>Page M-Bot (mm)</label>
                                    <input type="number" value="${globalConfig.pageMb}" onchange="SmartPrint.updateGlobal('pageMb', this.value)">
                                </div>
                                <div class="sp-form-group">
                                    <label>Page M-Left (mm)</label>
                                    <input type="number" value="${globalConfig.pageMl}" onchange="SmartPrint.updateGlobal('pageMl', this.value)">
                                </div>
                                <div class="sp-form-group">
                                    <label>Page M-Right (mm)</label>
                                    <input type="number" value="${globalConfig.pageMr}" onchange="SmartPrint.updateGlobal('pageMr', this.value)">
                                </div>
                            </div>

                            <div style="font-size: 11px; font-weight: bold; color: #4b5563; text-transform: uppercase; margin-bottom: 8px; border-top: 1px solid #bfdbfe; padding-top: 10px;">Global Page Numbers</div>
                            <div class="sp-form-grid">
                                <div class="sp-form-group">
                                    <label>Page No. Align</label>
                                    <select onchange="SmartPrint.updateGlobal('pageNoAlign', this.value)">
                                        <option value="left" ${globalConfig.pageNoAlign === 'left' ? 'selected' : ''}>Left</option>
                                        <option value="center" ${globalConfig.pageNoAlign === 'center' ? 'selected' : ''}>Center</option>
                                        <option value="right" ${globalConfig.pageNoAlign === 'right' ? 'selected' : ''}>Right</option>
                                    </select>
                                </div>
                                <div class="sp-form-group">
                                    <label>Page No. Format</label>
                                    <input type="text" value="${globalConfig.pageNoFormat}" onchange="SmartPrint.updateGlobal('pageNoFormat', this.value)" title="Use {n} for the page number">
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                // SECTION SPECIFIC PANELS
                Object.keys(fileConfigs).forEach(fileName => {
                    const cfg = fileConfigs[fileName];
                    html += `
                        <div class="sp-file-config">
                            <div class="sp-file-title sp-collapsible-header" onclick="SmartPrint.toggleCollapse(this)">Section / File: ${fileName}</div>

                            <div class="sp-collapsible-content">
                                <div class="sp-form-grid" style="margin-bottom: 10px;">
                                    <div class="sp-form-group">
                                        <label>Header (Left)</label>
                                        <input type="text" value="${cfg.headerLeft}" onchange="SmartPrint.updateConfig('${fileName}', 'headerLeft', this.value)">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Header (Right)</label>
                                        <input type="text" value="${cfg.headerRight}" onchange="SmartPrint.updateConfig('${fileName}', 'headerRight', this.value)">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Footer Text</label>
                                        <input type="text" value="${cfg.footerText}" onchange="SmartPrint.updateConfig('${fileName}', 'footerText', this.value)">
                                    </div>
                                </div>

                                <div class="sp-form-grid">
                                    <div class="sp-form-group">
                                        <label>Header M-Top (mm)</label>
                                        <input type="number" value="${cfg.headerMt}" onchange="SmartPrint.updateConfig('${fileName}', 'headerMt', this.value)">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Header M-Bot (mm)</label>
                                        <input type="number" value="${cfg.headerMb}" onchange="SmartPrint.updateConfig('${fileName}', 'headerMb', this.value)">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Footer M-Top (mm)</label>
                                        <input type="number" value="${cfg.footerMt}" onchange="SmartPrint.updateConfig('${fileName}', 'footerMt', this.value)">
                                    </div>
                                    <div class="sp-form-group">
                                        <label>Footer M-Bot (mm)</label>
                                        <input type="number" value="${cfg.footerMb}" onchange="SmartPrint.updateConfig('${fileName}', 'footerMb', this.value)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                });

                html += `</div></div>`;
                uiContainer.innerHTML = html;
            }

            // Expose update methods to global UI
            function updateConfig(fileName, key, value) {
                fileConfigs[fileName][key] = value;
                saveSettings();
            }

            function updateGlobal(key, value) {
                globalConfig[key] = value;
                saveSettings();
            }

            function resetBindingSettings() {
                // Reset values to the comb binding defaults for exactly 20 holes
                globalConfig.bindSpacing = 14.85;
                globalConfig.bindCombH = 5.8;
                globalConfig.bindCombW = 6.3;
                globalConfig.bindHoleH = 7.1;
                globalConfig.bindHoleW = 3.2;
                globalConfig.bindHoleL = 4.2;
                saveSettings();

                // Re-render UI to show updated numbers in inputs, then redraw pages
                buildUI();
                renderPages();
            }

            // Toggle Collapsible UI Sections
            function toggleCollapse(element) {
                element.classList.toggle('sp-expanded');
                const content = element.nextElementSibling;
                if (content && content.classList.contains('sp-collapsible-content')) {
                    content.classList.toggle('sp-expanded');
                }
            }

            // 7. Core Engine: Measure and Paginate
            function renderPages() {
                const source = document.querySelector(globalConfig.containerSelector);
                const pagesContainer = document.getElementById('sp-pages-container');
                pagesContainer.innerHTML = ''; // clear

                // APPLY BINDING MARKS CLASS
                if (globalConfig.showBindingMarks) {
                    pagesContainer.classList.add('sp-show-binding');
                } else {
                    pagesContainer.classList.remove('sp-show-binding');
                }

                const blocks = Array.from(source.querySelectorAll(globalConfig.blockSelector));

                let pageNumber = 1;
                let currentPage, currentContent;
                let activeConfig = fileConfigs[Object.keys(fileConfigs)[0]]; // default to first
                console.log(globalConfig.pageMl)

                document.documentElement.style.setProperty('--page-margin-left', globalConfig.pageMl+'mm');
                document.documentElement.style.setProperty('--bind-spacing', globalConfig.bindSpacing + 'mm');
                document.documentElement.style.setProperty('--bind-comb-h', globalConfig.bindCombH + 'mm');
                document.documentElement.style.setProperty('--bind-comb-w', globalConfig.bindCombW + 'mm');
                document.documentElement.style.setProperty('--bind-hole-h', globalConfig.bindHoleH + 'mm');
                document.documentElement.style.setProperty('--bind-hole-w', globalConfig.bindHoleW + 'mm');
                document.documentElement.style.setProperty('--bind-hole-l', globalConfig.bindHoleL + 'mm');

                                // --- TITLE PAGE LOGIC ---
                if (globalConfig.hasTitlePage) {
                    // Page 1: Title Page with customized text
                    const titlePage = document.createElement('div');
                    titlePage.className = 'sp-a4-page';
                    titlePage.style.padding = '0'; // Remove standard margins for full control

                    const titleWrapper = document.createElement('div');
                    titleWrapper.className = 'sp-title-page-wrapper';
                    titleWrapper.textContent = globalConfig.titlePageText; // Safe text insertion, honors line breaks

                    titlePage.appendChild(titleWrapper);
                    pagesContainer.appendChild(titlePage);

                    // Page 2: Blank Inner Cover
                    const blankPage = document.createElement('div');
                    blankPage.className = 'sp-a4-page';
                    pagesContainer.appendChild(blankPage);
                }
                // ------------------------

                function buildNewPage() {
                    currentPage = document.createElement('div');
                    currentPage.className = 'sp-a4-page';

                    // APPLY PAGE MARGINS (Global settings)
                    currentPage.style.paddingTop = globalConfig.pageMt + 'mm';
                    currentPage.style.paddingBottom = globalConfig.pageMb + 'mm';
                    currentPage.style.paddingLeft = globalConfig.pageMl + 'mm';
                    currentPage.style.paddingRight = globalConfig.pageMr + 'mm';

                    // HEADER
                    const header = document.createElement('div');
                    header.className = 'sp-page-header';
                    header.style.marginTop = activeConfig.headerMt + 'mm';
                    header.style.marginBottom = activeConfig.headerMb + 'mm';
                    header.innerHTML = `
                        <span>${activeConfig.headerLeft}</span>
                        <span>${activeConfig.headerRight}</span>
                    `;

                    // CONTENT AREA
                    currentContent = document.createElement('div');
                    currentContent.className = 'sp-page-content';

                    // FOOTER (Split into Text and Page Number)
                    const footer = document.createElement('div');
                    footer.className = 'sp-page-footer';
                    footer.style.marginTop = activeConfig.footerMt + 'mm';
                    footer.style.marginBottom = activeConfig.footerMb + 'mm';

                    const pText = globalConfig.pageNoFormat.replace('{n}', pageNumber);

                    footer.innerHTML = `
                        <div class="sp-footer-main">
                            <span>${activeConfig.footerText}</span>
                        </div>
                        <div class="sp-page-number-box" style="text-align: ${globalConfig.pageNoAlign}; margin-top: 4px;">
                            ${pText}
                        </div>
                    `;

                    currentPage.appendChild(header);
                    currentPage.appendChild(currentContent);
                    currentPage.appendChild(footer);

                    pagesContainer.appendChild(currentPage);
                    pageNumber++;
                }

                blocks.forEach((block) => {
                    // Check if file changes
                    if (block.hasAttribute(globalConfig.fileAttribute)) {
                        const fName = block.getAttribute(globalConfig.fileAttribute);
                        if (fileConfigs[fName]) {
                            activeConfig = fileConfigs[fName];
                        }
                        // Force break on new file section
                        if (currentContent && currentContent.children.length > 0) {
                            buildNewPage();
                        }
                    }

                    if (!currentContent) {
                        buildNewPage();
                    }

                    // Clone and append
                    const clone = block.cloneNode(true);
                    currentContent.appendChild(clone);

                    // The Measure Magic: Did it overflow?
                    if (currentContent.scrollHeight > currentContent.clientHeight) {
                        currentContent.removeChild(clone); // Too big! Take it out.
                        buildNewPage();                    // Make new page.
                        currentContent.appendChild(clone); // Put it on the new page.
                    }
                });
            }

            // Public API
            return {
                init,
                exit,
                updateConfig,
                updateGlobal,
                toggleCollapse,
                renderPages,
                resetBindingSettings
            };
        })();

        // Application Specific Trigger
        function startPrintMode() {
            /* hide navbar for printMode */
            $('#navbarNavbar').hide()
            $('body').css('grid-template-rows',$('#navbarNavbar').css('display') == 'block'?$('#navbarNavbar').height()+'px 1fr':'0px 1fr')

            // Simply call the global engine and pass in your target selectors
            SmartPrint.init({
                containerSelector: '#Viewer',
                blockSelector: '.cue',
                fileAttribute: 'data-file',
                defaultPageNoAlign: 'center' // You can change this to center or left
            });
        }

module.exports = {SmartPrint,startPrintMode}